import { createStore } from '@stencil/store';

export interface ShopInformation {
  numberOfShoppingItems: number;
  wishlistItemsNumber: number;
  subTotal: string;
}

export interface ShopStateStoreTypes {
  wishlistItemsNumber: number;
  numberOfShoppingItems: number;
  shopInformation: ShopInformation;
}

export const shopStateStore = createStore<ShopStateStoreTypes>({
  wishlistItemsNumber: 0,
  numberOfShoppingItems: 0,
  shopInformation: { numberOfShoppingItems: 0, wishlistItemsNumber: 0, subTotal: '0' }
});
